import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/lib/site-data";
import * as Icons from "lucide-react";

export default function Process() {
  return (
    <section data-testid="process-section" id="process" className="py-24 lg:py-32 bg-[#F4F9FC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Refining Process</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            A transparent, eight-step <span className="gold-gradient-text font-medium">workflow</span>.
          </h2>
        </div>
        <div className="relative">
          <div className="hidden lg:block absolute left-0 right-0 top-9 process-line" />
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6">
            {PROCESS_STEPS.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Circle;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  data-testid={`process-step-${i}`}
                  className="relative text-center group"
                >
                  <div className="mx-auto w-[72px] h-[72px] rounded-full bg-white border border-[#E5E5E5] flex items-center justify-center relative z-10 group-hover:border-[#D4AF37] transition-colors shadow-sm">
                    <Icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} />
                  </div>
                  <div className="mt-4 text-[10px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Step {i + 1}</div>
                  <div className="font-heading mt-1 text-base font-medium text-[#0A0A0A]">{s.title}</div>
                  <div className="mt-1 text-xs text-[#4B5563] leading-relaxed px-1">{s.desc}</div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
